var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 24,
    viewBox: "0 0 60 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1318_4422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.197 0.473585C41.6906 0.812895 41.9065 1.29101 41.8448 1.90794L38.8835 21.1561C38.791 21.6188 38.5442 21.9735 38.1432 22.2203C37.7114 22.4362 37.2795 22.4516 36.8477 22.2665L31.2953 19.9993L28.149 23.4233C27.6555 23.886 27.1002 24.0094 26.4833 23.7934C25.8972 23.5158 25.5888 23.0531 25.5579 22.4053V18.5187C25.5579 18.3336 25.6196 18.1794 25.743 18.056L33.5163 9.58868C33.763 9.24937 33.7476 8.91006 33.47 8.57075C33.1615 8.29314 32.8222 8.27771 32.4521 8.52448L23.0594 16.8993L18.9876 14.8634C18.4632 14.5858 18.1856 14.1539 18.1548 13.5679C18.1548 12.9818 18.4016 12.5345 18.8951 12.226L39.6238 0.381046C40.1791 0.10343 40.7035 0.134275 41.197 0.473585Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1318_4422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 23.69,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 23.886)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.a4522d6c4e8793411bf160650fa2502b.svg";
export { ForwardRef as ReactComponent };